import type { ReactNode } from "react";
import type { SetupDetails } from "../types/paymentMethodTypes";
import { CardSetupHero } from "./CardSetupHero";

/** Customer-facing card setup shell, used in the browser (QR link) and inside the app. */
export function CardSetupLayout({ details, title, showCard, children }: {
  details?: SetupDetails; title?: string; showCard?: boolean; children: ReactNode;
}) {
  return (
    <div className="min-h-full bg-background pb-[env(safe-area-inset-bottom)] lg:grid lg:grid-cols-[minmax(340px,420px)_1fr]">
      <CardSetupHero details={details} title={title} showCard={showCard} />
      <main className="mx-auto w-full max-w-md space-y-4 px-5 pb-8 pt-5 lg:max-w-lg lg:self-center lg:px-10 lg:py-12">
        {children}
      </main>
    </div>
  );
}
